import { createRouter, createWebHistory } from 'vue-router';

// Lazy load components for code splitting and better performance
const VisualKeyboard = () => import('@/components/VisualKeyboard/VisualKeyboard.vue');
const BreakPotGame = () => import('@/components/games/BreakPotGame.vue');
const TypefastPage = () => import('@/components/TypefastPage.vue');
const TypingLessons = () => import('@/components/TypingLessons/TypingLessons.vue');
const TypingQuestions = () => import('@/components/TypingQuestions/TypingQuestions.vue');
const GamePage = () => import('@/components/GamePage.vue');
const AboutPage = () => import('@/components/AboutPage.vue');
const HighScores = () => import('@/components/HighScores.vue');

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    // {
    //   path: '/',
    //   name: 'landingPage',
    //   component: LandingPage
    // },
    {
      path: '/',
      name: 'visualKeyboard',
      component: VisualKeyboard
    },
    // {
    //   path: '/visualKeyboard',
    //   name: 'visualKeyboard',
    //   component: VisualKeyboard
    // },
    {
      path: '/game',
      name: 'game',
      component: GamePage
    },
    {
      path: '/typingLessons',
      name: 'typingLessons',
      component: TypingLessons
    },
    {
      path: '/typingQuestions',
      name: 'typingQuestions',
      component: TypingQuestions
    },
    {
      path: '/about',
      name: 'about',
      component: AboutPage
    },
    {
      path: '/break-pot',
      name: 'BreakPotGame',
      component: BreakPotGame
    },
    {
      path: '/typefast',
      name: 'typefast',
      component: TypefastPage
    },
    {
      path: '/highScores',
      name: 'highScores',
      component: HighScores,
      props: (route) => ({ errors: route.params.errors, time: route.params.time }),
    },
    {
      path: '/:catchAll(.*)',
      redirect: '/'
    }
  ]
});

export default router;
